import axios from 'axios'
import { extractError } from '../utils/errorHandler'

const fail = (err) => {
  const apiError = extractError(err)
  return new Error(apiError.message || apiError.Message)
}

/**
 * Se existe webhook "Integrar ordens de produção" ativo e a última sincronização.
 * A tela inicial só mostra o botão de sincronizar quando existe.
 * Resposta: { available, hooks, lastJob }
 */
export const getWorkOrderSyncStatus = async () => {
  try {
    const { data } = await axios.get('integration/workOrder')
    return data
  } catch (err) {
    // sem a informação, o botão fica escondido
    return { available: false, hooks: 0, lastJob: null }
  }
}

/**
 * Inicia a sincronização (roda em segundo plano no servidor) e devolve o job:
 * { jobId, status: 'running' | 'done' | 'failed', startedAt, finishedAt, result, error }
 * Se já houver uma rodando, devolve a que está rodando.
 */
export const reSyncOrders = async () => {
  try {
    const { data } = await axios.post('integration/workOrder')
    return data
  } catch (err) {
    throw fail(err)
  }
}

/** Andamento de uma sincronização. */
export const getWorkOrderSyncJob = async (jobId) => {
  try {
    const { data } = await axios.get(`integration/workOrder/${jobId}`)
    return data
  } catch (err) {
    throw fail(err)
  }
}
